export enum PermissionTypeEnums {
  refundPayment = 1,
}
